/** Index at which a pointer at `y` would drop among items whose vertical midpoints are `midYs`, in order. */
export function indexFromMidpoints(midYs: readonly number[], y: number): number {
  let index = 0;
  for (const mid of midYs) {
    if (y < mid) break;
    index++;
  }
  return index;
}

/** Vertical distance from `y` to a box, zero when inside. */
export function distanceToBox(top: number, bottom: number, y: number): number {
  if (y < top) return top - y;
  if (y > bottom) return y - bottom;
  return 0;
}

/** Signed scroll speed near the edges of a scroll box, zero away from them. */
export function edgeScroll(top: number, bottom: number, y: number, zone = 60, divisor = 5): number {
  if (y < top + zone) return -Math.ceil((top + zone - y) / divisor);
  if (y > bottom - zone) return Math.ceil((y - (bottom - zone)) / divisor);
  return 0;
}

/** Threshold in pixels for a horizontal swipe to count, relative to the card width. */
export function swipeThreshold(width: number): number {
  return Math.min(96, Math.max(56, width * 0.28));
}
